import { render, staticRenderFns } from "./ActionNavigateTo.vue?vue&type=template&id=00a41370"
import script from "./ActionNavigateTo.vue?vue&type=script&lang=js"
export * from "./ActionNavigateTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports